import React from 'react';
import ContactHeader from './ContactUsUtils/ContactHeader';
import ContactSectionBL from './ContactUsUtils/ContactSectionBL';
import KeyContacts from './ContactUsUtils/KeyContacts';
import './ContactUs.css';
import ContactBanner from './ContactUsUtils/ContactBanner';
import BottomSection from './ContactUsUtils/BottomSection';
import Footer from '../Footer/Footer';
import { useSelector } from 'react-redux';

const ContactUsBL = () => {

  
    const contactBillund = useSelector((state) => state.ContactBillund);


  return (
    <div style={{ background: '#fff' }}>
      <ContactBanner />
      <div className="contact-us-container">
        <ContactHeader place="Billund" address1={contactBillund?.visitingAddress} address2="DK-7190 Billund" />
        <ContactSectionBL />
      </div>
      <div style={{marginTop:"40px", borderTop: "1px solid #E0E0E0"}}>
        <Footer/>
      </div>
    </div>
  );
};

export default ContactUsBL;
